import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import DocumentosGeneradosPorImprimir from './docsGeneradPorImprimir';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { validarCampoString, esNumeroEntero } from '../../funciones_globales/utils';
import global_axios from '../../funciones_globales/interaccionapi';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { setDocumentosPorImprimir } from '../../actions/ventas/act_ven02';
import { formatearNumeroEntero } from '../../funciones_globales/format';
import { cargarCatalogosAsync } from '../../funciones_globales/catalogos';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';

class FormVen16  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            proformaId: '',
            nroIdentificacion: '',
            nombreCliente: '',
            telefono: '',
            direccionEnvio: '',
            ciudadEnvio: '',
            fechaDespacho: '',
            numeroEtiquetas: 1,
            isVisibleEtiqGenPorImp: false,            
            transporte_sel: null
        };
        
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);        
        this.getProformaById = this.getProformaById.bind(this);
        this.generarEtiquetas = this.generarEtiquetas.bind(this);
    }
    
    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0416');        
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0416');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    getOptions_Transportes(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('TRANSPORTE', input, callback)
        }
    }

    getProformaById(){
        let idProforma = this.state.proformaId;
        if (validarCampoString(idProforma, 6)){
          this.props.cambiar_VisualizacionLoading(true);
    
          global_axios({
            method: 'GET',
            url: `/proformas/${idProforma}/datosdespacho`
          })
          .then((response)=> {
            let infoEnvioProforma = response.data;
            try {
                if (infoEnvioProforma!==null){             
                    this.setState({
                        nroIdentificacion: infoEnvioProforma.CedulaRuc,
                        nombreCliente: `${infoEnvioProforma.Nombre} (${infoEnvioProforma.Representante})`,
                        telefono: infoEnvioProforma.Telefono,
                        direccionEnvio: infoEnvioProforma.DireccionEnvio,
                        ciudadEnvio: infoEnvioProforma.CiudadEnvio,
                        fechaDespacho: infoEnvioProforma.FechaDespacho
                  });
                  
                  this.props.cambiar_VisualizacionLoading(false);
        
                }else{
                  this.props.cambiar_VisualizacionLoading(false);
                  alert(`La proforma: ${idProforma} no existe.`);
                }
            } catch (error) {
                alert(`Ocurrió un error al cargar los datos de envío. Error: ${error}`);
            }
          })
          .catch((error)=>{
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message);
          });
        }
        else{
          alert('No ha especificado un No. de Proforma válido.');
        }
    }

    generarEtiquetas(){
        if(!validarCampoString(this.state.proformaId, 6)){
            alert('No ha especificado correctamente un No. de Proforma válido.');
            return;
        }

        if(this.state.transporte_sel===null){
            alert('No ha especificado correctamente el Transporte.');
            return;
        }

        if(!esNumeroEntero(this.state.numeroEtiquetas)){
            alert('No ha especificado correctamente el número de etiquetas a generar.');
            return;
        }else{
            if(formatearNumeroEntero(this.state.numeroEtiquetas)<1){
                alert('No ha especificado correctamente el número de etiquetas a generar.');
                return;
            }
        }

        let etiquetasPorImprimir = [];

        for (let i = 0; i < this.state.numeroEtiquetas; i++) {
            etiquetasPorImprimir.push({
                Nro: (i+1),
                NroDocumento: `${this.state.proformaId}-${(i+1)}`,
                EstadoImp: 'POR IMPRIMIR'
            });
        }
        
        this.props.setDocumentosPorImprimir(etiquetasPorImprimir);
        this.setState({
            isVisibleEtiqGenPorImp: true
        });
    }

    limpiar(){
        this.setState({
            proformaId: '',
            nroIdentificacion: '',
            nombreCliente: '',
            telefono: '',
            direccionEnvio: '',
            ciudadEnvio: '',
            fechaDespacho: '',
            numeroEtiquetas: 1,
            isVisibleEtiqGenPorImp: false,
            transporte_sel: null
        });
    }

    render(){
        return (
            <div>
                <ContenedorForm porc_ancho={55}>
                    <HeaderForm>
                        <TituloForm>Etiqueta Despacho</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <Row margen_arriba={10}>
                            <ContainerCol className='col-sm-3'>
                                <LabelForm>Proforma:</LabelForm>
                                <InputSearch tipoInput='text' nombre='proformaId' valor={this.state.proformaId} func_CambiarValor={this.handleInputChange}
                                    func_BuscarValor={this.getProformaById} func_OnFocus={()=>{this.limpiar()}}/>
                            </ContainerCol>                          
                        </Row>
                        <Row margen_arriba={10}>
                            <ContainerCol className='col-sm-3'>
                                <LabelForm>Ruc:</LabelForm>
                                <InputText type='text' value={this.state.nroIdentificacion===null?'':this.state.nroIdentificacion} disabled={true}/>
                            </ContainerCol>                            
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-8'>
                                <LabelForm>Nombre:</LabelForm>
                                <InputText type='text' value={this.state.nombreCliente===null?'':this.state.nombreCliente} disabled={true}/>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-3'>
                                <LabelForm>Teléfono:</LabelForm>
                                <InputText type='text' value={this.state.telefono===null?'':this.state.telefono} disabled={true}/>
                            </ContainerCol>                            
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-8'>
                                <LabelForm>Dirección Envío:</LabelForm>
                                <InputText type='text' value={this.state.direccionEnvio===null?'':this.state.direccionEnvio} disabled={true}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-4'>
                                <LabelForm>Ciudad:</LabelForm>
                                <InputText type='text' value={this.state.ciudadEnvio===null?'':this.state.ciudadEnvio} disabled={true}/>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-6'>
                                <LabelForm>Transporte:</LabelForm>
                                <ReactSelectAsync value={this.state.transporte_sel} func_loadOptions={this.getOptions_Transportes}
                                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({transporte_sel: value })}}/>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-3'>
                                <LabelForm>Fecha Despacho:</LabelForm>
                                <InputText type='text' value={this.state.fechaDespacho===null?'':this.state.fechaDespacho.substr(0, 10)} disabled={true}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-3'>
                                <LabelForm>No. Etiquetas:</LabelForm>
                                <InputText type='number' name='numeroEtiquetas' value={this.state.numeroEtiquetas} onChange={this.handleInputChange}/>
                            </ContainerCol>
                        </Row>                        
                        <Row margen_arriba={20}>
                            <ContainerCol className='col-sm-12'>
                                <div className='btn-group pull-right'>
                                    <button type='button' className='btn btn-info btn-sm' onClick={this.generarEtiquetas}><i className='fa fa-print fa-lg'></i> Generar Etiquetas</button>
                                    <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                                </div>
                            </ContainerCol>
                        </Row>
                    </CuerpoForm>
                </ContenedorForm>
                <DocumentosGeneradosPorImprimir
                    tipoComprob={'ETIQ'}
                    isVisibleCompGenPorImp={this.state.isVisibleEtiqGenPorImp}
                    tituloDocPorImp='Etiquetas por imprimir'
                    parametroAdic={this.state.transporte_sel!==null?this.state.transporte_sel.label.trim().substr(0, this.state.transporte_sel.label.trim().length-5):''}
                    onClose = {()=>{this.setState({isVisibleEtiqGenPorImp: false}); this.props.setDocumentosPorImprimir([]);}}
                />
            </div>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {
    return bindActionCreators({ generar_LogAuditoriaIngresoForm,
                                generar_LogAuditoriaSalidaForm,
                                cambiar_VisualizacionLoading,
                                setDocumentosPorImprimir
                            }, dispatch)
});

export default connect(null, mapDispatchToProps)(FormVen16);